import { useState } from "react";
import { Modal, ModalHeader, ModalBody, Input } from "reactstrap";
// icones
import { icons } from "../../../utils/helpers/icons/index";
// componentes
import ComponentIcon from "../../../utils/helpers/icons/component";

export default function ModalIcons(props) {
  const { isOpen, toggle, setIconSelected, iconSelected } = props;
  //   pesquisa
  const [search, setSearch] = useState("");

  function selectIcon() {
    setTimeout(() => {
      toggle();
    }, 400);
  }

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Configuração do Ranking</ModalHeader>
        <ModalBody>
          <Input
            className="form-control"
            placeholder="Pesquise pelo nome do ícone"
            type="text"
            onChange={(e) => setSearch(e.target.value)}
          />

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
              marginTop: 20,
            }}
          >
            {icons
              .filter((icon) =>
                icon.toLowerCase().includes(search.toLowerCase())
              )
              .map((e, i) => (
                <ComponentIcon
                  key={i}
                  icon={e}
                  setIconSelected={setIconSelected}
                  iconSelected={iconSelected}
                  toggleBackdrop={selectIcon}
                />
              ))}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
